import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import { DesktopDateTimePicker } from '@mui/x-date-pickers'
import { FormHelperText } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'

interface DateTimePickerProps {
  label: string
  inputName: string
  value: Dayjs | null
  minDate?: Dayjs | null
  handleInputChange: (inputName: string, value: any) => void
}

function DateTimePicker({ label, inputName, value, minDate, handleInputChange }: DateTimePickerProps) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleChange = (dateTime: Dayjs | null) => {
    handleInputChange(inputName, dateTime)
  }

  return (
    <>
      <DesktopDateTimePicker
        label={t(label)}
        format="DD/MM/YYYY hh:mm A"
        value={value ? dayjs(value) : null}
        minDate={minDate ? dayjs(minDate) : undefined}
        onChange={newDate => handleChange(newDate)}
        slotProps={{
          textField: { fullWidth: true, error: !!errorForm['inputName'] }
        }}
      />
      <FormHelperText error={errorForm['inputName']}>{msgForm['inputName']}</FormHelperText>
    </>
  )
}

export default DateTimePicker
